export default "__VITE_ASSET__eb7e9d5a__"